import { render, staticRenderFns } from "./DetalhesEstornarItemPedido.vue?vue&type=template&id=4b72be8c&scoped=true"
import script from "./DetalhesEstornarItemPedido.vue?vue&type=script&lang=js"
export * from "./DetalhesEstornarItemPedido.vue?vue&type=script&lang=js"
import style0 from "./DetalhesEstornarItemPedido.vue?vue&type=style&index=0&id=4b72be8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72be8c",
  null
  
)

export default component.exports